export default __webpack_public_path__ + "static/media/smorder-logo.03b50fd9.png";